import { gql } from "@apollo/client";

export const GET_PROMO_PRODUCTS_BY_PROMO_EVENT_ID = gql`
  query GetPromoProductsByPromoEventId($params: GetPromoProductsByPromoEventIdInput!) {
    getPromoProductsByPromoEventId(params: $params) {
      columns {
        key
        title
      }
      data {
        promoProductId
        promotedPrice
        discountPercentage
        discountAmount
        packQuantity
        unitSize
        unitOfMeasure
        product {
          productId
          productName
          productDescription
          productKey
          upcItemNumber
          glItemNumber
          glItemDescription
          productCategory {
            productCategoryId
            productCategoryKey
            productCategoryName
            productCategoryDescription
          }
        }
      }
      count
      page
      limit
      isAllProductsInScope
    }
  }
`;
